import Base from '@studiometa/js-toolkit';
import withBreakpointManager from '@studiometa/js-toolkit/decorators/withBreakpointManager';
import SolutionsMobile from './SolutionsMobile';
import SolutionsDesktop from './SolutionsDesktop';

/**
 * Homepage class.
 */
export default class Solutions extends withBreakpointManager(Base, [
  ['sm md', SolutionsMobile],
  ['lg xl xxl', SolutionsDesktop],
]) {
  static config = {
    name: 'Solutions',
    refs: ['links[]', 'cursor', 'mask', 'links_container', 'overlay'],
  };
}
